// File: frontend/src/utils/positionColors.ts
// Canonical position palette for the league/DFS product (owner-locked
// 2026-07-13). The colors restate the scoring identity so the draft board
// silently teaches the point system:
//   FW = red   (Attacking:   goals, shots)
//   MF = blue  (Creating:    GC/SC - the passing-TD proxy)
//   DF = gold  (Progressing: IP/IC - the yards proxy)
//   GK = green
// Classic mode keeps its own legacy maps (Classic is tabled - do not unify).
// Full literal class strings on purpose: Tailwind's JIT can't see composed
// class names.

const CELL: Record<string, string> = {
  FW: 'bg-red-500/15 border-red-500/40 text-red-300',
  MF: 'bg-accent-light-blue/15 border-accent-light-blue/40 text-accent-light-blue',
  DF: 'bg-amber-400/15 border-amber-400/40 text-amber-300',
  GK: 'bg-emerald-500/15 border-emerald-500/40 text-emerald-300',
};

const BADGE: Record<string, string> = {
  FW: 'bg-red-500/20 text-red-400 border-red-500/30',
  MF: 'bg-accent-light-blue/20 text-accent-light-blue border-accent-light-blue/30',
  DF: 'bg-amber-400/20 text-amber-300 border-amber-400/30',
  GK: 'bg-emerald-500/20 text-emerald-400 border-emerald-500/30',
};

/** Translucent fill + outline for board/grid cells. */
export const positionCellClasses = (pos?: string | null): string =>
  CELL[pos ?? ''] ?? 'bg-primary-dark border-gray-700/60 text-gray-400';

/** Compact pill style for position badges (trade modal, lists). */
export const positionBadgeClasses = (pos?: string | null): string =>
  BADGE[pos ?? ''] ?? 'bg-gray-600/20 text-gray-400 border-gray-600/30';

const TEXT: Record<string, string> = {
  FW: 'text-red-400',
  MF: 'text-accent-light-blue',
  DF: 'text-amber-300',
  GK: 'text-emerald-400',
};

/** Text-only position color - the quiet variant for roster/list surfaces
 *  (Sleeper parity: loud color lives on the draft board ONLY; everywhere
 *  else the palette appears as small colored position text). */
export const positionTextClasses = (pos?: string | null): string =>
  TEXT[pos ?? ''] ?? 'text-gray-500';
